import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import DatePicker from "react-datepicker";
import scrollToComponent from 'react-scroll-to-component';
// import "react-datepicker/dist/react-datepicker.css";

import * as api from '../../../constants/api';
import * as endpoint from '../../../constants/endpoints';
import * as holdConst from '../../../constants/hold';
import * as storage from '../../../persistance/storage';

import {isAdmin} from '../../../utils/auth';
import {formatShape, formatLocation, displayDateFromDbString, formatPrice, formatCut, formatPolish, formatSymmetry, formatFluorescence, formatMeasurements, formatDepth, formatTable, formatRatio, displayDateTimeFromTimestamp} from '../../../utils/formatting';
import {dynamicSort} from '../../../utils/sort';

import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';

import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
import * as transfersActionCreators from '../../../actions/transfers';
let allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, transfersActionCreators);


class Transfers extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let today = new Date();
    let startDate = new Date();
    startDate.setMonth(today.getMonth() - 3);


		this.state = {
      sortParam: 'request_date',
      searchTerm: '',

      confirmModalOpen: false,
      confirmModalType: null,
      confirmMessage: '',
      currentTransfer: null,
      confirmError: '',

      editModalOpen: false,
      editSku: '',
      editMessage: '',
      editMessageError: '', 

      addModalOpen: false,
      addSku: '',
      addLocation: '',
      addMessage: '',

      searchPendingRequest: false,
      searchResult: null,
      searchFailure: false,

      expandedTransfer: [],

      startDate: startDate,
      endDate: today,

      scrollPos: 0,

      enablePopups: true,
      initialLoad: false,
    };

    
    this.updateAllPageData();

    // Fetch locations list
    if(this.props.transfers.locations === null) {
      this.props.fetchLocations()
      .then((respData) => {
        this.props.transfersSetLocations(respData.locations);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }

    // Fetch non-LGD transfer counts
    this.props.transfersCountFetch()
    .then((respData) => {
      this.props.transfersSetCounts(respData);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    // Fetch LGD transfer counts
    this.props.transfersCountFetch(true)
    .then((respData) => {
      this.props.transfersSetLgdCounts(respData);
      this.setState({
        initialLoad: true,
      });
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    // Bind event listeners
    this.getScrollPos = ::this.getScrollPos;
	}

  componentDidMount() {
    window.addEventListener('scroll', this.getScrollPos, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.initialLoad === true && this.props.transfers.countsLgd["open"] > prevProps.transfers.countsLgd["open"]) {
      this.props.commonAlert('A new LGD transfer has been added');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.getScrollPos, false);
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    });
  }

  updateAllPageData() {

    this.props.transfersOpenFetch()
    .then((respData) => {
      this.props.transfersOpenSetList(respData.transfers);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    this.props.transfersIncomingFetch()
    .then((respData) => {
      this.props.transfersPendingSetList(respData.transfers);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    this.props.transfersClosedFetch(this.props.transfers.closedPage)
    .then((respData) => {
      this.props.transfersClosedSetList(respData.transfers);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  updateCurrentPageData(closedPage = null) {

    let pageNum = this.props.transfers.closedPage;
    if(closedPage) {
      pageNum = closedPage;
    }
  
    // Get current page
    let isOpenPage = window.location.pathname.includes('transfers');
    let isPendingPage = window.location.pathname.includes('pending');
    let isClosedPage = window.location.pathname.includes('closed');

    // Fetch non-LGD transfer counts
    this.props.transfersCountFetch()
    .then((respData) => {
      this.props.transfersSetCounts(respData);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    // Fetch LGD transfer counts
    this.props.transfersCountFetch(true)
    .then((respData) => {
      this.props.transfersSetLgdCounts(respData);
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });

    if(isOpenPage) {
      this.props.transfersOpenFetch()
      .then((respData) => {
        this.props.transfersOpenSetList(respData.transfers);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }

    if(isPendingPage) {
      this.props.transfersIncomingFetch()
      .then((respData) => {
        this.props.transfersPendingSetList(respData.transfers);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }

    if(isClosedPage) {
      this.props.transfersClosedFetch(pageNum)
      .then((respData) => {
        this.props.transfersClosedSetList(respData.transfers);
      })
      .catch((errorResp) => {
        console.error(errorResp);
      });
    }
  }

  userNav(page) {
    this.context.router.push('/' + page);
  }

  formatTransferArray(transferArray) {
    
    if(transferArray === null) {
      return [];
    }

    let returnArray = [];

    for(let i = 0; i < transferArray.length; i++) {

      if(transferArray[i].diamond.is_lgd) {
        continue;
      }

      let tempItem = JSON.parse(JSON.stringify(transferArray[i]));
      tempItem['sku'] = transferArray[i].diamond.web_item;
      tempItem['shape'] = formatShape(transferArray[i].diamond) + ' ' + transferArray[i].diamond.carat_weight + ' ' + transferArray[i].diamond.color + ' ' + transferArray[i].diamond.clarity;
      tempItem['status'] = transferArray[i].diamond.in_wallet ? 'Loose' : 'Mounted';
      tempItem['name'] = transferArray[i].request_user.first_name + ' ' + transferArray[i].request_user.last_name;
      tempItem['currentLocation'] = formatLocation(transferArray[i].diamond, this.props.transfers.locations) + ' (' + transferArray[i].diamond.location + ')';
      // Store number comes straight from the location record (LocationResp always sends
      // asc_id). Do NOT reintroduce a name->number lookup: the old hardcoded map keyed on
      // 'Ft Worth' while the DB says 'Fort Worth', so Fort Worth (36), DDNY (51) and ECJ
      // Watch Boutique (0) all rendered an empty "()". No falsy guard here either — ECJ's
      // asc_id is legitimately 0, which `|| ''` would silently blank out again.
      tempItem['toLocation'] = transferArray[i].request_location.short_name + ' (' + transferArray[i].request_location.asc_id + ')';
      returnArray.push(tempItem);
    }
    return returnArray;
  }

  getDisplayList() {

    let isOpen = !this.props.route.fullHistory && !this.props.route.pendingTransfers;
    let isPending = this.props.route.pendingTransfers;
    let isClosed = this.props.route.fullHistory;

    if(isOpen) {
      return this.formatTransferArray(this.props.transfers.open);
    } else if(isPending) {
      return this.formatTransferArray(this.props.transfers.pending);
    } else if(isClosed) {
      return this.formatTransferArray(this.props.transfers.closed);
    } else {
      return [];
    }
  }

  getDupeList(displayList) {

    let dupeList = [];
    let skuList = [];

    if(displayList && displayList.length > 0 && !this.props.route.fullHistory) {
      for(let i = 0; i < displayList.length; i++) {
        if(skuList.includes(displayList[i].diamond.web_item) && !dupeList.includes(displayList[i].diamond.web_item)) {
          dupeList.push(displayList[i].diamond.web_item);
        } else {
          skuList.push(displayList[i].diamond.web_item);
        }
      }
    }
    return dupeList;
  }

  setSort(sortKey) {
    this.setState({ sortParam: sortKey });
  }

  changeSearchTerm(evt) {
    this.setState({ searchTerm: evt.target.value });
  }

  searchMatch(transferItem) {
    
    let terms = this.state.searchTerm.trim().toLowerCase().split(" ");

    if(terms.length === 0) {
      return true;
    }

    let a1 = transferItem['sku'].trim().toLowerCase();
    let a2 = transferItem['shape'].trim().toLowerCase();
    let a3 = transferItem['status'].trim().toLowerCase();
    let a4 = transferItem['name'].trim().toLowerCase();
    let a5 = transferItem['currentLocation'].trim().toLowerCase();
    let a6 = transferItem['toLocation'].trim().toLowerCase();

    for(let i = 0; i < terms.length; i++) {
      if(!a1.includes(terms[i]) && !a2.includes(terms[i]) && !a3.includes(terms[i]) && !a4.includes(terms[i]) && !a5.includes(terms[i]) && !a6.includes(terms[i])) {
        return false;
      }
    }
    return true;
  }

  getExportUrl() {
    let export_value = this.props.route.fullHistory ? 'full' : 'open';
    if(this.props.route.pendingTransfers) {
      export_value = 'pending';
    }
    return api.API_URL + endpoint.TRANSFERS_EXPORT + '?export_type=' + export_value + '&auth_token=' + storage.get('token') + '&start_date=' + this.state.startDate.toISOString().split('T')[0] + '&end_date=' + this.state.endDate.toISOString().split('T')[0];
  }

  isApproved(transfer) {
    if(isAdmin()) {
      if(transfer.approve_hq_date || transfer.reject_hq_date) {
        if(transfer.approve_hq_date) {
          return 'controlButton inactive selected';
        } else {
          return 'controlButton inactive';
        }
      }
      return 'controlButton';
    } else {
      if(transfer.approve_local_date || transfer.reject_local_date) {
        if(transfer.approve_local_date) {
          return 'controlButton inactive selected';
        } else {
          return 'controlButton inactive';
        }
      }
      return 'controlButton';
    }
  }

  isRejected(transfer) {
    if(isAdmin()) {
      if(transfer.approve_hq_date || transfer.reject_hq_date) {
        if(transfer.reject_hq_date) {
          return 'controlButton inactive selected';
        } else {
          return 'controlButton inactive';
        }
      }
      return 'controlButton';
    } else {
      if(transfer.approve_local_date || transfer.reject_local_date) {
        if(transfer.reject_local_date) {
          return 'controlButton inactive selected';
        } else {
          return 'controlButton inactive';
        }
      }
      return 'controlButton';
    }
  }

  isPending(transfer) {
    if(transfer.approve_hq_date || transfer.reject_hq_date) {
      return 'controlButton inactive';
    }
    if(transfer.pending_date) {
      return 'controlButton inactive selected';
    }
    return 'controlButton';
  }

  isShippedButtonClass(transfer) {
    if(transfer.is_shipped) {
      return 'controlButton inactive selected';
    }
    return 'controlButton';
  }

  isShippedRowClass(transfer) {
    // Open/Pending rows carry no extra styling. This branch used to try to tint
    // Online-Sales-bound rows via `transfer.toLocation == 'Online Sales'`, but toLocation
    // has always been built as 'Online Sales (50)', so the comparison was never true and
    // the highlight never rendered in production. Removed rather than switched on. The
    // .onlineRow rule still exists in _transfers.scss if it is ever wanted — key it off
    // transfer.request_location.asc_id === 50, not the formatted string.
    if(this.props.route.fullHistory === false && this.props.route.pendingTransfers === false) {
      return '';
    }
    return this.props.route.fullHistory && transfer.is_shipped ? ' shippedRow' : '';
  }

  cancelButtonClass(transfer) {
    if(transfer.is_shipped) {
      return 'controlButton inactive';
    } else if(transfer.is_cancelled) {
      return 'controlButton inactive selected';
    }
    return 'controlButton';
  }

  openApproveModal(evt, transfer) {

    evt.stopPropagation();

    if(isAdmin()) {
      if(transfer.approve_hq_date || transfer.reject_hq_date) {
        return false;
      }
    } else {
      if(transfer.approve_local_date || transfer.reject_local_date) {
        return false;
      }
    }
    
    this.setState({
      confirmModalOpen: true,
      confirmModalType: 'approve',
      confirmMessage: transfer.comments ? transfer.comments : '',
      currentTransfer: transfer,
    });
  }

  openRejectModal(evt, transfer) {

    evt.stopPropagation();

    if(isAdmin()) {
      if(transfer.approve_hq_date || transfer.reject_hq_date) {
        return false;
      }
    } else {
      if(transfer.approve_local_date || transfer.reject_local_date) {
        return false;
      }
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalType: 'reject',
      confirmMessage: transfer.comments ? transfer.comments : '',
      currentTransfer: transfer,
    });
  }

  openCancelModal(evt, transfer) {

    evt.stopPropagation();

    if(isAdmin()) {
      // if(transfer.approve_hq_date || transfer.reject_hq_date) {
      //   return false;
      // }
    } else {
      if(transfer.approve_local_date || transfer.reject_local_date) {
        return false;
      }
    }

    this.setState({
      confirmModalOpen: true,
      confirmModalType: 'cancel',
      confirmMessage: '',
      currentTransfer: transfer,
    });
  }

  openEditModal(evt, transfer) {

    evt.stopPropagation();

    this.setState({
      editModalOpen: true,
      editSku: '',
      editMessage: '',
      editMessageError: '',
      currentTransfer: transfer,
      searchPendingRequest: false,
      searchResult: transfer.balance_diamond,
      searchFailure: false,
    });
  }

  openAddModal() {
    this.setState({
      addModalOpen: true,
      addSku: '',
      addLocation: '',
      addMessage: '',
      searchPendingRequest: false,
      searchResult: null,
      searchFailure: false,
    });
  }

  closeConfirmModal() {
    this.setState({
      confirmModalOpen: false,
      confirmModalType: null,
      confirmMessage: '',
      currentTransfer: null,
      confirmError: '',
    });
  }

  closeEditModal() {
    this.setState({
      editModalOpen: false,
      editSku: '',
      editMessage: '',
      editMessageError: '',
      currentTransfer: null,
      searchPendingRequest: false,
      searchResult: null,
      searchFailure: false,
    });
  }

  closeAddModal() {
    this.setState({
      addModalOpen: false,
      addSku: '',
      addLocation: '',
      addMessage: '',
      searchPendingRequest: false,
      searchResult: null,
      searchFailure: false,
    });
  }

  changeConfirmMessage(evt) {
    this.setState({ confirmMessage: evt.target.value });
  }

  changeEditMessage(evt) {
    this.setState({ editMessage: evt.target.value });
  }

  changeAddMessage(evt) {
    this.setState({ addMessage: evt.target.value });
  }

  changeAddLocation(evt) {
    this.setState({ addLocation: parseInt(evt.target.value) });
  }

  getConfirmTitle() {
    if(this.state.confirmModalType == 'approve') {
      return 'Approve Transfer Request';
    }
    if(this.state.confirmModalType == 'reject') {
      return 'Not Available Transfer Request'; 
    }
    if(this.state.confirmModalType == 'cancel') {
      return 'Cancel Transfer Request'; 
    }
    return 'Transfer Request';
  }

  transferModalAction() {

    if((this.state.confirmModalType == 'reject' || this.state.confirmModalType == 'cancel') && !this.state.confirmMessage) {
      this.setState({
        confirmError: 'Please enter a message', 
      });
      return null;
    }

    if(isAdmin()) {
      if(this.state.confirmModalType == 'approve') {
        this.approveRequestAction();
      } else if(this.state.confirmModalType == 'reject') {
        this.rejectRequestAction();
      } else if(this.state.confirmModalType == 'cancel') {
        this.cancelTransfer();
      }
    } else {
      if(this.state.confirmModalType == 'approve') {
        this.approveRequestLocalAction();
      } else if(this.state.confirmModalType == 'reject') {
        this.rejectRequestLocalAction();
      } else if(this.state.confirmModalType == 'cancel') {
        this.cancelTransfer();
      }
    }
    return null;
  }

  approveRequestAction() {
    
    let transferData = {
      transfer_id: this.state.currentTransfer.id,
      comments: this.state.confirmMessage,
    }

    this.props.transferApprove(transferData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.closeConfirmModal();
      this.props.commonAlert('Transfer updated');
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  rejectRequestAction() {

    let transferData = {
      transfer_id: this.state.currentTransfer.id,
      comments: this.state.confirmMessage,
    }

    this.props.transferReject(transferData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.closeConfirmModal();
      this.props.commonAlert('Transfer updated');
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  approveRequestLocalAction() {
    
    let transferData = {
      transfer_id: this.state.currentTransfer.id,
      comments: this.state.confirmMessage,
    }

    this.props.transferApproveLocal(transferData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.closeConfirmModal();
      this.props.commonAlert('Transfer updated');
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  rejectRequestLocalAction() {

    let transferData = {
      transfer_id: this.state.currentTransfer.id,
      comments: this.state.confirmMessage,
    }

    this.props.transferRejectLocal(transferData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.closeConfirmModal();
      this.props.commonAlert('Transfer updated');
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  searchDiamondBySku(sku) {

    if(!sku || this.state.searchPendingRequest) {
      return false;
    }

    this.setState({
      searchPendingRequest: true,
      searchResult: null,
      searchFailure: false,
    });  

    this.props.transferCheckDiamond(sku)
    .then((respData) => {
      this.setState({
        searchPendingRequest: false,
        searchResult: respData.diamond,
        searchFailure: respData.diamond === null,
      });
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  changeEditSku(evt) {
    this.setState({ editSku: evt.target.value });
  }

  changeAddSku(evt) {
    this.setState({ addSku: evt.target.value });
  }

  editDiamondAction() {

    if(!this.state.editMessage) {
      this.setState({
        editMessageError: 'Please enter a message', 
      });
      return null;
    }

    let balanceData = null;
    if(this.state.currentTransfer.balance_diamond === null && this.state.searchFailure === false && this.state.searchResult) {
      balanceData = this.state.searchResult.web_item;
    }

    let transferData = {
      transfer_id: this.state.currentTransfer.id,
      balance_sku: balanceData,
      comments: this.state.editMessage,
    }

    this.props.transferEditRequest(transferData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.props.commonAlert('Transfer updated');
      this.closeEditModal();
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  addDiamondAction() {

    if(!this.state.searchResult && !this.state.addLocation) {
      return null;
    }

    let addData = {
      diamonds: [ this.state.searchResult.id ],
      location_id: this.state.addLocation,
      message_body: this.state.addMessage,
    }

    this.props.transferAddTransfer(addData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.props.commonAlert('Transfer created');
      this.closeAddModal();
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  renderFoundDiamond(diamond) {
    return <div className='foundDiamondWrapper'>
      <div className='foundRow'>
        <div className='foundLabel'>Diamond SKU:</div>
        <div className='foundValue'>{diamond.web_item}</div>
      </div>
      <div className='foundRow'>
        <div className='foundLabel'>Diamond Info:</div>
        <div className='foundValue'>{formatShape(diamond) + ' ' + diamond.carat_weight + ' ' + diamond.color + ' ' + diamond.clarity}</div>
      </div>
      <div className='foundRow'>
        <div className='foundLabel'>Diamond Location:</div>
        <div className='foundValue'>{formatLocation(diamond, this.props.transfers.locations)}</div>
      </div>
    </div>;
  }

  getPageTitle() {
    let pageTitle = this.props.route.fullHistory ? 'Closed Transfers' : 'Open Transfers';
    if(this.props.route.pendingTransfers) {
      pageTitle = 'Pending Transfers';
    }
    if(!isAdmin()) {
      if(pageTitle == 'Open Transfers') {
        pageTitle = 'Outgoing Transfers';
      }
      if(pageTitle == 'Pending Transfers') {
        pageTitle = 'Incoming Transfers';
      }
    }
    return pageTitle;
  }

  getOpenName() {
    if(isAdmin()) {
      return 'Open';
    } else {
      return 'Outgoing';
    }
  }

  getPendingName() {
    if(isAdmin()) {
      return 'Pending';
    } else {
      return 'Incoming';
    }
  }

  getCloseName() {
    return 'Closed';
  }

  toggleExpanded(transferId) {

    let idFound = false;
    let expandedClone = [];

    for(let i = 0; i < this.state.expandedTransfer.length; i++) {
      if(this.state.expandedTransfer[i] !== transferId) {
        expandedClone[i] = this.state.expandedTransfer[i];
      } else {
        idFound = true;
      }
    }

    if(!idFound) {
      expandedClone.push(transferId);
    }

    this.setState({
      expandedTransfer: expandedClone,
    })
  }

  getTransferStatus(transfer) {

    if(transfer.is_cancelled) {
      return "Cancelled";
    }

    if(transfer.approve_hq_date === null && transfer.reject_hq_date === null) {
      return "Waiting for HQ";
    }

    if(transfer.reject_hq_date !== null) {
      return "NA by HQ";
    }

    if(transfer.approve_hq_date !== null) {

      if(transfer.approve_local_date === null && transfer.reject_local_date === null) {
        return "Waiting for Store";
      }

      if(transfer.approve_local_date !== null) {

        if(transfer.is_shipped) {
          return "Shipped";
        } else {
          return "Sending";
        }
      }

      if(transfer.reject_local_date !== null) {
        return "NA by Store";
      }      
    }

    return "";
  }

  getTransferRowClass(transfer) {

    if(this.props.route.fullHistory === false && this.props.route.pendingTransfers === true && !isAdmin()) {
      
      let transferStatus = this.getTransferStatus(transfer);
      const greenStatus = [
        'Shipped',
        'Sending',
      ];

      const redStatus = [
        'NA by HQ',
        'NA by Store',
      ];

      if(greenStatus.includes(transferStatus)) {
        return 'transferDiamondRow acceptRow';
      } else {
        return redStatus.includes(transferStatus) ? 'transferDiamondRow rejectRow' : 'transferDiamondRow';
      }
    }

    if(!this.props.route.fullHistory) {
      return 'transferDiamondRow';
    }

    let tallModifier = '';
    if(isAdmin()) {
      tallModifier = ' tallTransferRow';
    }

    if(transfer.reject_hq_date !== null || transfer.reject_local_date) {
      return 'transferDiamondRow rejectRow' + tallModifier;
    } else {
      return 'transferDiamondRow acceptRow' + tallModifier;
    }
  }

  markTransferShipped(evt, transfer) {

    evt.stopPropagation();

    if(transfer.is_shipped) {
      return;
    }

    let shippedData = {
      transfer_id: transfer.id,
    }

    this.props.transferMarkShipped(shippedData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.props.commonAlert('Transfer updated');
      this.closeEditModal();
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  cancelTransfer() {

    if(this.state.currentTransfer.is_cancelled) {
      return;
    }

    let cancelData = {
      transfer_id: this.state.currentTransfer.id,
      comments: this.state.confirmMessage,
    }

    this.props.transferMarkCancelled(cancelData)
    .then((respData) => {
      this.updateCurrentPageData();
      this.props.commonAlert('Transfer cancelled');
      this.closeConfirmModal();
    })
    .catch((errorResp) => {
      console.error(errorResp);
    });
  }

  setStartDate(date) {
    this.setState({startDate: date});
  }

  setEndDate(date) {
    this.setState({endDate: date});
  }

  openNav() {
    this.userNav('transfers');
    setTimeout(() => {
      this.updateCurrentPageData();
    }, 200);
  }

  pendingNav() {
    this.userNav('pending');
    setTimeout(() => {
      this.updateCurrentPageData();
    }, 200);
  }

  closedNav() {
    this.userNav('closed');
    setTimeout(() => {
      this.updateCurrentPageData();
    }, 200);
  }

  incrementPageNumber() {

    this.props.transfersUpdateClosedPage(this.props.transfers.closedPage + 1);
    this.updateCurrentPageData(this.props.transfers.closedPage + 1);
    scrollToComponent(this.transferListDiv, {
      offset: 0, 
      align: 'top', 
      duration: 500, 
      ease: 'inOutCube',
    });
  }

  decrementPageNumber() {

    this.props.transfersUpdateClosedPage(this.props.transfers.closedPage - 1);
    this.updateCurrentPageData(this.props.transfers.closedPage - 1);
    scrollToComponent(this.transferListDiv, {
      offset: 0, 
      align: 'top', 
      duration: 500, 
      ease: 'inOutCube',
    });
  }

  toggleLab(evt) {
    if(this.props.route.fullHistory) {
      this.userNav('lab/closed');
    } else if(this.props.route.pendingTransfers) {
      this.userNav('lab/pending');
    } else {
      this.userNav('lab/transfers');
    }
  }

  togglePopups(evt) {
    this.setState({
      enablePopups: !this.state.enablePopups,
    })
  }

  isOnHold(diamond) {
    if(diamond.last_hold === null) {
      return false;
    }
    let holdTime = new Date(diamond.last_hold);
    let now = new Date();

    if((now - holdTime) <= holdConst.HOLD_DURATION) {
      return true;
    }
    return false;
  }

  isFrequent(transfer) {
    if(!transfer.last_transfer) { return false; }

    const THRESHOLD = 24;  // In hours

    const now = new Date();
    const last = new Date(transfer.last_transfer);

    const diff = now.getTime() - last.getTime();
    const limit = THRESHOLD * 60 * 60 * 1000;

    return diff < limit;
  }

	render() {

    let displayList = this.getDisplayList();
    let dupeList = this.getDupeList(displayList);
    let sortedList = (displayList).sort(dynamicSort(this.state.sortParam, this.state.sortParam == 'request_date'));

		return <div className='Transfers'>
      <div className='pageHeader'>
        <div className='pageTitle'>Natural Diamonds</div>
        <div className='welcomeMessage' ref={(div) => { this.transferListDiv = div; }}>
          {this.getPageTitle()}
          <div className='typeWrapper'>
            <div className='typeLabel'>Diamond Type:</div>
            <div className='typeDropdown'>
              <select value={'natural'} onChange={this.toggleLab.bind(this)}>
                <option value='natural'>Natural</option>
                <option value='lab'>Lab Grown</option>
              </select>
            </div>
          </div>
          <div className={'addButton actionButton'} onClick={::this.openAddModal}>Add</div>
        </div>
        <div className='searchWrapper'>
          <input type='text' value={this.state.searchTerm} onChange={::this.changeSearchTerm} placeholder='Search transfers' />
        </div>
      </div>
      <div className={this.props.route.fullHistory ? 'linkRowWrapper datesIncluded' : 'linkRowWrapper'}>
        <div 
          className={!this.props.route.fullHistory && !this.props.route.pendingTransfers ? 'toggleLink headerLink selected' : 'toggleLink headerLink'} 
          onClick={::this.openNav}>
          {this.getOpenName()}
          {this.props.transfers.counts["open"] !== null ?
            <span>&nbsp;({this.props.transfers.counts["open"].toLocaleString()})</span> :
            null
          }
        </div>
        <div 
          className={this.props.route.pendingTransfers ? 'toggleLink headerLink selected' : 'toggleLink headerLink'} 
          onClick={::this.pendingNav}>
          {this.getPendingName()}
          {this.props.transfers.counts["pending"] !== null ?
            <span>&nbsp;({this.props.transfers.counts["pending"].toLocaleString()})</span> :
            null
          }
        </div>
        <div 
          className={this.props.route.fullHistory ? 'toggleLink headerLink selected' : 'toggleLink headerLink'} 
          onClick={::this.closedNav}>
          {this.getCloseName()}
          {this.props.transfers.counts["closed"] !== null ?
            <span>&nbsp;({this.props.transfers.counts["closed"].toLocaleString()})</span> :
            null
          }
        </div>
        <a href={this.getExportUrl()} download='export.csv'>
          <div className={'downloadLink headerLink'}>Export</div>
        </a>
        {this.props.route.fullHistory ?
          <div className='dateRangeWrapper'>
            <div className='dateFieldWrapper'>
              <div className='dateFieldLabel'>Start Date</div>
              <DatePicker 
                className='dateField startDateField' 
                selected={this.state.startDate} 
                onChange={date => this.setStartDate(date)} />
            </div>
            <div className='dateSeparation'>-</div>
            <div className='dateFieldWrapper'>
              <div className='dateFieldLabel'>End Date</div>
              <DatePicker 
                className='dateField endDateField' 
                selected={this.state.endDate} 
                popperPlacement="bottom-end" 
                onChange={date => this.setEndDate(date)} />
            </div>
          </div> :
          null
        }
      </div>
      <div className='toggleControls'>
        <div className='toggleIndication' onClick={() => this.toggleLab()}>
          <div className='toggleArrow'>&lt;</div>
          <div className='toggleValue'>
            <div className='valueBubble'>{this.props.transfers.countsLgd["open"] ? this.props.transfers.countsLgd["open"] : '0'}</div>
          </div>
          <div className='toggleLabel' style={{ display: 'none' }}></div>
        </div>
        <div className='dropdownControls' style={{ display: 'none' }}>
          <div className='dropdownCheckboxWrapper'>
            <input
              type='checkbox'
              value={this.state.enablePopups}
              onChange={this.togglePopups.bind(this)} />
          </div>
          <div className='dropdownLabel'>Enable notification popups?</div>
        </div>
      </div>
      {displayList ?
        <div>
          {displayList.length > 0 ?
            <div className='transferList'>
              <div className={this.state.scrollPos > 200 ? 'transferEntryHeader transferEntry floatingHeader' : 'transferEntryHeader transferEntry'}>
                <div 
                  className={this.state.sortParam == 'request_date' ? 'dateItem transferItem sortSelected' : 'dateItem transferItem'}
                  onClick={() => this.setSort('request_date')}>
                  Date
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'sku' ? 'transferItem skuItem sortSelected' : 'transferItem skuItem'}
                  onClick={() => this.setSort('sku')}>
                  SKU
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'gia' ? 'transferItem giaItem sortSelected' : 'transferItem giaItem'}
                  onClick={() => this.setSort('gia')}>
                  GIA
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'shape' ? 'transferItem descriptionItem sortSelected' : 'transferItem descriptionItem'}
                  onClick={() => this.setSort('shape')}>
                  Description
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'name' ? 'requestNameItem transferItem sortSelected' : 'requestNameItem transferItem'}
                  onClick={() => this.setSort('name')}>
                  Requested By
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'currentLocation' ? 'currentLocationItem transferItem sortSelected' : 'currentLocationItem transferItem'}
                  onClick={() => this.setSort('currentLocation')}>
                  From
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'toLocation' ? 'transferLocationItem transferItem sortSelected' : 'transferLocationItem transferItem'}
                  onClick={() => this.setSort('toLocation')}>
                  To
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
                <div 
                  className={this.state.sortParam == 'status' ? 'statusItem transferItem sortSelected' : 'statusItem transferItem'}
                  onClick={() => this.setSort('status')}>
                  Status
                  <span className='sortIndicator'><i className={"fas fa-chevron-down"}></i></span>
                </div>
              </div>
              {displayList.map((transfer, i) => {

                if(this.state.searchTerm && !this.searchMatch(transfer)) {
                  return null;
                }

                return <div className={this.state.expandedTransfer.includes(transfer.id) ? 'transferEntry expanded' + this.isShippedRowClass(transfer) : 'transferEntry' + this.isShippedRowClass(transfer)} key={i} onClick={() => this.toggleExpanded(transfer.id)}>
                  <div className={this.getTransferRowClass(transfer)}>
                    <div className={'dateItem transferItem'}>
                    <div className='dateWrapper'>{displayDateFromDbString(transfer.request_date)}</div>
                      {this.isOnHold(transfer.diamond) ?
                        <div className='holdWrapper'>On Hold</div> :
                        null
                      }
                    </div>
                    <div className={`skuItem transferItem ${dupeList.includes(transfer.diamond.web_item) ? 'dupeSku' : ''} ${this.isFrequent(transfer) ? 'freqSku' : ''}`}>
                      {transfer.diamond.web_item}
                    </div>
                    <div className={'giaItem transferItem'}>{transfer.diamond.gia_number}</div>
                    <div className={'descriptionItem transferItem'}>{formatShape(transfer.diamond) + ' ' + transfer.diamond.carat_weight + ' ' + transfer.diamond.color + ' ' + transfer.diamond.clarity}</div>
                    <div className={'requestNameItem transferItem'}>{transfer.request_user.first_name + ' ' + transfer.request_user.last_name}</div>
                    <div className={'currentLocationItem transferItem'}>{formatLocation(transfer.diamond, this.props.transfers.locations)} ({transfer.diamond.location})</div>
                    <div className={'transferLocationItem transferItem'}>{transfer.toLocation}</div>
                    <div className={'statusItem transferItem'}>{this.getTransferStatus(transfer)}</div>
                    {this.props.route.fullHistory === false && this.props.route.pendingTransfers === true && !isAdmin() ?
                      <div className='controlsWrapper'></div> :
                      <div className='controlsWrapper'>
                        {isAdmin() ?
                          <div className={this.isApproved(transfer)} onClick={(evt) => this.openApproveModal(evt, transfer)}>Transfer</div> :
                          <div className={this.isApproved(transfer)} onClick={(evt) => this.openApproveModal(evt, transfer)}>Sending</div>
                        }
                        <div className={this.isRejected(transfer)} onClick={(evt) => this.openRejectModal(evt, transfer)}>NA</div>
                        {isAdmin() ?
                          <div className='controlButton' onClick={(evt) => this.openEditModal(evt, transfer)}>Balance</div> :
                          <div className='controlButton' onClick={(evt) => this.openEditModal(evt, transfer)}>Comment</div>
                        }
                        {this.props.route.fullHistory ?
                          <div className={this.isShippedButtonClass(transfer)} onClick={(evt) => this.markTransferShipped(evt, transfer)}>Shipped</div> :
                          null
                        }
                        {isAdmin() ?
                          <div className={this.cancelButtonClass(transfer)} onClick={(evt) => this.openCancelModal(evt, transfer)}>Cancel</div> :
                          null
                        }
                      </div>
                    }
                  </div>
                  <div className='transferBalanceRow'>
                    <div className={'transferDiamondWrapper detailBlock'}>
                      <div className='subrowTitle'>Transfer Diamond Details</div>
                      <div className='detailRow'>
                        <div className='detailLabel'>SKU:</div>
                        <div className='detailValue'>{transfer.diamond ? transfer.diamond.web_item : 'None'}</div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Info:</div>
                        <div className='detailValue'>{transfer.diamond ? (formatShape(transfer.diamond) + ' ' + transfer.diamond.carat_weight + ' ' + transfer.diamond.color + ' ' + transfer.diamond.clarity) : 'None'}</div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Location:</div>
                        <div className='detailValue'>{transfer.diamond ? formatLocation(transfer.diamond, this.props.transfers.locations) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Measure:</div>
                        <div className='detailValue'>{transfer.diamond ? formatMeasurements(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Mounting:</div>
                        <div className='detailValue'>{transfer.diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Price:</div>
                        <div className='detailValue'>{transfer.diamond ? formatPrice(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Cut:</div>
                        <div className='detailValue'>{transfer.diamond ? formatCut(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Polish:</div>
                        <div className='detailValue'>{transfer.diamond ? formatPolish(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Symmetry:</div>
                        <div className='detailValue'>{transfer.diamond ? formatSymmetry(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Depth:</div>
                        <div className='detailValue'>{transfer.diamond ? formatDepth(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Lab:</div>
                        <div className='detailValue'>
                          {transfer.diamond ? 
                            <span>
                              {transfer.diamond.lab}
                              {transfer.diamond.lab == 'GIA' && transfer.diamond.gia_number ?
                                <span>{' - ' + transfer.diamond.gia_number}</span> :
                                null
                              }
                            </span> : 
                            <span>None</span>
                          }
                        </div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Table:</div>
                        <div className='detailValue'>{transfer.diamond ? formatTable(transfer.diamond) : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Flour:</div>
                        <div className='detailValue'>{transfer.diamond ? transfer.diamond.flourescence : 'None'}</div>
                      </div>
                      <div className='detailRow' style={{ display: 'none' }}>
                        <div className='detailLabel'>Ratio:</div>
                        <div className='detailValue'>{transfer.diamond ? formatRatio(transfer.diamond) : 'None'}</div>
                      </div>
                    </div>
                    <div className={'balanceWrapper detailBlock'}>
                      <div className='subrowTitle'>Balance Diamond</div>
                      <div className='detailRow'>
                        <div className='detailLabel'>SKU:</div>
                        <div className='detailValue'>{transfer.balance_diamond ? transfer.balance_diamond.web_item : 'None'}</div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Info:</div>
                        <div className='detailValue'>{transfer.balance_diamond ? (formatShape(transfer.balance_diamond) + ' ' + transfer.balance_diamond.carat_weight + ' ' + transfer.balance_diamond.color + ' ' + transfer.balance_diamond.clarity) : 'None'}</div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Location:</div>
                        <div className='detailValue'>{transfer.balance_diamond ? formatLocation(transfer.balance_diamond, this.props.transfers.locations) : 'None'}</div>
                      </div>
                    </div>
                    <div className={'commentsWrapper detailBlock'}>
                      <div className='subrowTitle'>Comments</div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Associate:</div>
                        <div className='detailValue'>
                          {transfer.request_comments ? 
                            <span>
                              {transfer.request_comments.trim().split(/(?:\r\n|\r|\n)/).map((item, key) => {
                                return (
                                  <span key={key}>
                                    {item}<br />
                                  </span>
                                );
                              })}
                            </span> : 
                            <span>'None'</span>
                          }
                        </div>

                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>HQ:</div>
                        <div className={'detailValue emValue'}>
                          {transfer.hq_comments ? 
                            <span>
                              {transfer.hq_comments.trim().split(/(?:\r\n|\r|\n)/).map((item, key) => {
                                return (
                                  <span key={key}>
                                    {item}<br />
                                  </span>
                                );
                              })}
                            </span> : 
                            <span>'None'</span>
                          }
                        </div>
                      </div>
                      <div className='detailRow'>
                        <div className='detailLabel'>Store:</div>
                        <div className='detailValue'>
                          {transfer.local_comments ? 
                            <span>
                              {transfer.local_comments.trim().split(/(?:\r\n|\r|\n)/).map((item, key) => {
                                return (
                                  <span key={key}>
                                    {item}<br />
                                  </span>
                                );
                              })}
                            </span> : 
                            <span>'None'</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div className={'historyWrapper detailBlock'}>
                      <div className='subrowTitle'>History</div>
                      {transfer.approve_date ?
                        <div className='detailRow'>
                          <div className='detailLabel'>Transfer Initiated:</div>
                          <div className='detailValue'>
                            {transfer.approve_user ?
                              <div className='detailName'>{`${transfer.approve_user.first_name} ${transfer.approve_user.last_name}`}</div> :
                              null
                            }
                            <div className='detailDate'>{displayDateTimeFromTimestamp(transfer.approve_date)}</div>
                          </div>
                        </div> :
                        null
                      }
                      {transfer.approve_hq_date ?
                        <div className='detailRow'>
                          <div className='detailLabel'>HQ Approval:</div>
                          <div className='detailValue'>
                            {transfer.approve_user_hq ?
                              <div className='detailName'>{`${transfer.approve_user_hq.first_name} ${transfer.approve_user_hq.last_name}`}</div> :
                              null
                            }
                            <div className='detailDate'>{displayDateTimeFromTimestamp(transfer.approve_hq_date)}</div>
                          </div>
                        </div> :
                        null
                      }
                      {transfer.reject_hq_date ?
                        <div className='detailRow'>
                          <div className='detailLabel'>HQ NA:</div>
                          <div className='detailValue'>
                            {transfer.reject_user_hq ?
                              <div className='detailName'>{`${transfer.reject_user_hq.first_name} ${transfer.reject_user_hq.last_name}`}</div> :
                              null
                            }
                            <div className='detailDate'>{displayDateTimeFromTimestamp(transfer.reject_hq_date)}</div>
                          </div>
                        </div> :
                        null
                      }
                      {transfer.approve_local_date ?
                        <div className='detailRow'>
                          <div className='detailLabel'>Store Approval:</div>
                          <div className='detailValue'>
                            {transfer.approve_user_local ?
                              <div className='detailName'>{`${transfer.approve_user_local.first_name} ${transfer.approve_user_local.last_name}`}</div> :
                              null
                            }
                            <div className='detailDate'>{displayDateTimeFromTimestamp(transfer.approve_local_date)}</div>
                          </div>
                        </div> :
                        null
                      }
                      {transfer.reject_local_date ?
                        <div className='detailRow'>
                          <div className='detailLabel'>Store NA:</div>
                          <div className='detailValue'>
                            {transfer.reject_user_local ?
                              <div className='detailName'>{`${transfer.reject_user_local.first_name} ${transfer.reject_user_local.last_name}`}</div> :
                              null
                            }
                            <div className='detailDate'>{displayDateTimeFromTimestamp(transfer.reject_local_date)}</div>
                          </div>
                        </div> :
                        null
                      }
                    </div>
                  </div>
                </div>;
              })}
              {window.location.pathname.includes('closed') && this.props.transfers.counts["closed"] ?
                <div className='pageWrapper'>
                  {this.props.transfers.closedPage && this.props.transfers.closedPage > 1 ?
                    <div className='prevArrow' onClick={::this.decrementPageNumber}>&lt;&nbsp;Prev</div> :
                    null
                  }
                  <div className='pageStatus'>Page: {this.props.transfers.closedPage}</div>
                  {this.props.transfers.closedPage && this.props.transfers.counts["closed"] && this.props.transfers.closedPage < Math.ceil(this.props.transfers.counts["closed"]  / 100) ?
                    <div className='nextArrow' onClick={::this.incrementPageNumber}>Next&nbsp;&gt;</div> :
                    null
                  }
                </div> :
                null
              }














            </div> :
            <div className='noResults'>No Transfers Found</div>
          }
        </div> :
        <RhinoLoading message='Loading transfers...' />
      }
      <RhinoModal
        open={this.state.confirmModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={::this.closeConfirmModal}>&times;</div>
          <div className='transferModalTitle'>{this.getConfirmTitle()}</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              className={this.state.confirmError ? 'error' : ''}
              onChange={::this.changeConfirmMessage} 
              value={this.state.confirmMessage}
              placeholder={this.getConfirmTitle() == 'Not Available Transfer Request' || this.getConfirmTitle() == 'Cancel Transfer Request' ? 'Please include a message' : 'Include an optional message'}></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={::this.transferModalAction}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.editModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={::this.closeEditModal}>&times;</div>
          <div className='transferModalTitle'>Edit Transfer</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          {isAdmin() ?
            <div>
              {this.state.searchResult ?
                <div>{this.renderFoundDiamond(this.state.searchResult)}</div> :
                <div className={'transferModalInput modalSearchInput'}>
                  <input type='text' placeholder='Diamond SKU' value={this.state.editSku} onChange={::this.changeEditSku} onBlur={() => this.searchDiamondBySku(this.state.editSku)} />
                  <div className={this.state.searchPendingRequest ? 'searchIconWrapper searchIconWrapperLoading' : 'searchIconWrapper'}>
                    <i className={"fas fa-search modalSearchIcon"} onClick={() => this.searchDiamondBySku(this.state.editSku)}></i>
                    <i className={"fas fa-spinner fa-pulse modalSearchLoadingIcon"}></i>
                  </div>
                </div>
              }
              {this.state.searchFailure ?
                <div className='feedbackSearchFailure'>Diamond not found. Please check the SKU and try again.</div> :
                null
              }
            </div> :
            null
          }
          <div className='transferModalInput'>
            <textarea
              type='text' 
              className={this.state.editMessageError ? 'error' : ''}
              onChange={::this.changeEditMessage} 
              value={this.state.editMessage}
              placeholder='Please include a message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={::this.editDiamondAction} disabled={this.state.searchPendingRequest}>Save</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.addModalOpen}>
        <div className={'transferModal addModal'}>
          <div className='closeModal' onClick={::this.closeAddModal}>&times;</div>
          <div className='transferModalTitle'>Create New Transfer</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          {this.state.searchResult ?
            <div>{this.renderFoundDiamond(this.state.searchResult)}</div> :
            <div className={'transferModalInput modalSearchInput'}>
              <input type='text' placeholder='Diamond SKU' value={this.state.addSku} onChange={::this.changeAddSku} onBlur={() => this.searchDiamondBySku(this.state.addSku)} />
              <div className={this.state.searchPendingRequest ? 'searchIconWrapper searchIconWrapperLoading' : 'searchIconWrapper'}>
                <i className={"fas fa-search modalSearchIcon"} onClick={() => this.searchDiamondBySku(this.state.addSku)}></i>
                <i className={"fas fa-spinner fa-pulse modalSearchLoadingIcon"}></i>
              </div>
            </div>
          }
          {this.state.searchFailure ?
            <div className='feedbackSearchFailure'>Diamond not found. Please check the SKU and try again.</div> :
            null
          }
          <div className='transferModalInput'>
              {this.props.transfers.locations === null ?
                <select disabled={true} className='locationSelect'>
                  <option value=''>Locations loading...</option>
                </select> :
                <select className='locationSelect' value={this.state.addLocation} onChange={::this.changeAddLocation}>
                  <option value=''>Select transfer location</option>
                  {this.props.transfers.locations.map((location, i) => {
                    return <option value={location.id} key={i}>{location.short_name}</option>;
                  })}
                </select>
              }
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={::this.changeAddMessage} 
              value={this.state.addMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={::this.addDiamondAction} disabled={this.state.searchPendingRequest}>Create Transfer</button>
          </div>
        </div>
      </RhinoModal>
		</div>;
	}
}
export default Transfers;

function mapStateToProps(state) {
  return {
    transfers: state.transfers,
    user: state.user,
  };
}

export const TransfersContainer = connect(
  mapStateToProps,
  allActionCreators
)(Transfers);